export default __webpack_public_path__ + "static/media/facebook.e0309f98.png";